function Navbar() {
    return (
    <div className="navbar">
        <div className="right">
          <ul>
            <li>
              MERN STACK DEVELOPMENT
            </li>
          </ul>
        </div>
      </div>
    )
}

export default Navbar;